import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';

import { RECAPTCHA_SITE_KEY } from '../../utils/constant';

const Captcha = ({ onChange, errors, touched, value }) => {
  const captchaRef = useRef(null);

  // Tokens are single-use: when the form is reset after a submit, reset the widget too.
  useEffect(() => {
    if (!value && captchaRef.current && captchaRef.current.getValue()) {
      captchaRef.current.reset();
    }
  }, [value]);

  const hasError = errors.recaptcha && touched.recaptcha;

  return (
    <>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${hasError ? 'error' : ''}`}
      >
        <ReCAPTCHA
          ref={captchaRef}
          sitekey={RECAPTCHA_SITE_KEY}
          name="recaptcha"
          onChange={onChange}
          onExpired={() => onChange('')}
        />
        {hasError && (
          <div className="error_messages" style={{ position: 'static' }}>
            <StatusError size={16} color="#C12335" aria-hidden="true" />{' '}
            <span className="frg-body-font-14px">{errors.recaptcha}</span>
          </div>
        )}
      </div>
    </>
  );
};

Captcha.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({ recaptcha: PropTypes.string }).isRequired,
  touched: PropTypes.shape({ recaptcha: PropTypes.bool }).isRequired,
  value: PropTypes.string
};

Captcha.defaultProps = {
  value: ''
};

export default Captcha;
